const PendingPropertyTable = ({
    properties,
    updatingStatus,
    isAdmin,
    onView,
    onApprove,
    onReject,
}) => {
    return (
        <div className="overflow-x-auto">
            <table className="min-w-full border">
                <thead>
                    <tr>
                        <th>Tiêu đề</th>
                        <th>Dự án</th>
                        <th>Loại hình</th>
                        <th>Diện tích</th>
                        <th>Giá</th>
                        <th>Người đăng</th>
                        <th>Hành động</th>
                    </tr>
                </thead>

                <tbody>
                    {properties.map((property) => (
                        <tr key={property.id}>
                            <td>{property.title}</td>

                            <td>{property.projectName || "-"}</td>

                            <td>{property.propertyType}</td>

                            <td>{property.area} m²</td>

                            <td>
                                {property.price?.toLocaleString()} VND
                            </td>

                            <td>
                                {property.user?.name || "Không rõ"}
                            </td>

                            <td>
                                <button
                                    onClick={() => onView(property)}
                                >
                                    Xem
                                </button>

                                {isAdmin && (
                                    <>
                                        <button
                                            disabled={
                                                updatingStatus[property.id]
                                            }
                                            onClick={() =>
                                                onApprove(property.id)
                                            }
                                        >
                                            Phê duyệt
                                        </button>

                                        <button
                                            disabled={
                                                updatingStatus[property.id]
                                            }
                                            onClick={() =>
                                                onReject(property.id)
                                            }
                                        >
                                            Từ chối
                                        </button>
                                    </>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PendingPropertyTable;